module.exports = __webpack_public_path__ + "img/jiaoshijie.7497d3d7.png";